import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
import { makeCompatibility } from "./armor-system-L6MZWGYJ.js";
import { makeSpacing } from "./armor-system-CU52Z6TQ.js";
import { makeTypography } from "./armor-system-JWKWXFED.js";
import { defaultThemeStructure } from "./armor-system-7XMVF6JI.js";
import { merge } from "./armor-system-PC23IDY4.js";
import { themeStructure } from "./armor-system-BVCAH5KN.js";
import { transition } from "./armor-system-AWQPJ3AQ.js";
import { color_exports } from "./armor-system-BO3IBKNV.js";
import { breakpointBetween, breakpointDown, breakpointOnly, breakpointUnit, breakpointUp, getBreakPointValues, mapBreakpointCodeToValue, mapBreakpointWidthToCode } from "./armor-system-REXRNICS.js";
import { __objRest, __spreadProps, __spreadValues } from "./armor-system-JQVN7XCJ.js";

// src/util/popper.ts
import { css as css3 } from "styled-components";

// src/theme/createTheme.ts
import { getTheme, themeInfo } from "@deliveryhero/armor-tokens";

// src/theme/createArmorSubTheme.ts
import { flatten as flatten2 } from "flat";

// src/theme/legacy/makeArmorSubTheme.ts
import { flatten } from "flat";

// src/theme/legacy/makeBreakpoints.ts
var makeBreakpoints = function makeBreakpoints(theme) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : breakpointUnit;
  var breakpoints = theme.breakpoints;
  var values = getBreakPointValues(theme);
  var base = {
    values: values,
    keys: Object.keys(values),
    unit: unit
  };
  return __spreadProps(__spreadValues(__spreadValues({}, breakpoints), base), {
    unit: unit,
    mapCodeToValue: mapBreakpointCodeToValue,
    mapWidthToCode: mapBreakpointWidthToCode,
    up: breakpointUp,
    down: breakpointDown,
    only: breakpointOnly,
    between: breakpointBetween
  });
};

// src/theme/legacy/makeArmorSubTheme.ts
var makeArmorSubTheme = function makeArmorSubTheme() {
  var declaration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var theme = merge(defaultThemeStructure, declaration);
  theme.spacing = makeSpacing(theme);
  theme.breakpoints = makeBreakpoints(theme);
  theme.typography = makeTypography(theme);
  makeCompatibility(theme);
  theme.referenceIndex = flatten({
    body: theme.body,
    shape: theme.shape,
    typography: theme.typography,
    color: theme.color,
    elevation: theme.elevation,
    transition: theme.transition
  });
  theme.$initialized = true;
  return theme;
};

// src/theme/makeCompatibility.ts
var makeCompatibility2 = function makeCompatibility2(theme) {
  var legacyTheme = makeArmorSubTheme();
  theme.body = theme.body || legacyTheme.body;
  theme.spacing = legacyTheme.spacing;
  theme.spacingFactor = legacyTheme.spacingFactor;
  theme.shape = legacyTheme.shape;
  theme.transition = legacyTheme.transition;
  theme.color = __spreadValues(__spreadValues({}, legacyTheme.color), theme.color);
  theme.typography = __spreadValues(__spreadValues({}, legacyTheme.typography), theme.typography);
  theme.breakpoints = __spreadValues(__spreadValues({}, legacyTheme.breakpoints), theme.breakpoints);
  theme.elevation = __spreadValues(__spreadValues({}, legacyTheme.elevation), theme.elevation);
};

// src/theme/createArmorSubTheme.ts
var createArmorSubTheme = function createArmorSubTheme() {
  var themeInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var theme = merge(themeStructure, themeInput);
  makeCompatibility2(theme);
  theme.referenceIndex = __spreadValues(__spreadValues({}, flatten2(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, theme.color), theme.borderRadius), theme.borderWidth), theme.breakpoint), theme.duration), theme.elevation), theme.fontFamily), theme.lineHeight), theme.letterSpacing), theme.fontSize), theme.fontWeight), theme.opacity), theme.sizing), theme.layoutSpacing), theme.typography), theme.zIndex), {
    maxDepth: 1
  })), flatten2({
    body: theme.body,
    shape: theme.shape,
    typography: theme.typography,
    color: theme.color,
    elevation: theme.elevation,
    transition: theme.transition
  }));
  theme.$initialized = true;
  return theme;
};

// src/theme/createTheme.ts
var createTheme = function createTheme(themeInput) {
  var armorSubTheme = createArmorSubTheme(themeInput == null ? void 0 : themeInput.armor);
  if (themeInput == null ? void 0 : themeInput.name) {
    var name = themeInput.name,
      _themeInput$mode = themeInput.mode,
      mode = _themeInput$mode === void 0 ? "light" : _themeInput$mode;
    var themeModeName = themeInfo[name][mode];
    if (themeModeName) {
      var themeObject = getTheme(themeModeName);
      var customThemeObject = {
        color: __spreadValues({}, themeObject.Color),
        borderRadius: __spreadValues({}, themeObject.BorderRadius),
        borderWidth: __spreadValues({}, themeObject.BorderWidth),
        breakpoint: __spreadValues({}, themeObject.Breakpoint),
        duration: __spreadValues({}, themeObject.Duration),
        elevation: __spreadValues({}, themeObject.Elevation),
        fontFamily: __spreadValues({}, themeObject.FontFamily),
        lineHeight: __spreadValues({}, themeObject.LineHeight),
        letterSpacing: __spreadValues({}, themeObject.LetterSpacing),
        fontSize: __spreadValues({}, themeObject.FontSize),
        fontWeight: __spreadValues({}, themeObject.FontWeight),
        opacity: __spreadValues({}, themeObject.Opacity),
        sizing: __spreadValues({}, themeObject.Sizing),
        layoutSpacing: __spreadValues({}, themeObject.Spacing),
        typography: __spreadValues({}, themeObject.Typography),
        zIndex: __spreadValues({}, themeObject.ZIndex)
      };
      armorSubTheme = createArmorSubTheme(customThemeObject);
    }
  }
  return __spreadProps(__spreadValues({}, themeInput), {
    armor: armorSubTheme
  });
};

// src/theme/createDefaultTheme.ts
var createDefaultTheme = function createDefaultTheme() {
  return createTheme();
};
var defaultTheme;
var createDefaultThemeCached = function createDefaultThemeCached() {
  if (!defaultTheme) {
    defaultTheme = createDefaultTheme();
  }
  return defaultTheme;
};

// src/theme/legacy/makeTheme.ts
var makeTheme = function makeTheme() {
  var declaration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __spreadProps(__spreadValues({}, declaration), {
    armor: makeArmorSubTheme(declaration.armor)
  });
};

// src/theme/legacy/makeDefaultTheme.ts
var makeDefaultTheme = function makeDefaultTheme() {
  return makeTheme();
};
var makeLightTheme = makeDefaultTheme;
var defaultTheme2;
var makeDefaultThemeCached = function makeDefaultThemeCached() {
  if (!defaultTheme2) {
    defaultTheme2 = makeDefaultTheme();
  }
  return defaultTheme2;
};

// src/theme/legacy/util.ts
var getAvailableTheme = function getAvailableTheme(theme) {
  var _a;
  return (_a = theme == null ? void 0 : theme.armor) != null ? _a : makeDefaultThemeCached().armor;
};

// src/theme/util.ts
var getAvailableThemeBase = function getAvailableThemeBase(theme) {
  var _a;
  return (_a = theme == null ? void 0 : theme.armor) != null ? _a : createDefaultThemeCached().armor;
};
var isLegacyTheme = function isLegacyTheme(theme) {
  var _a;
  return ((_a = theme == null ? void 0 : theme.armor) == null ? void 0 : _a.isLegacy) || false;
};
var getAvailableTheme2 = function getAvailableTheme2(theme) {
  return isLegacyTheme(theme) ? getAvailableTheme(theme) : getAvailableThemeBase(theme);
};

// src/mixins/borderRadius.ts
var borderRadius = function borderRadius(radius) {
  return function (_ref) {
    var theme = _ref.theme;
    var _a;
    var currentTheme = getAvailableTheme2(theme);
    if (radius in currentTheme.shape.borderRadius) {
      return (_a = currentTheme.shape.borderRadius[radius]) != null ? _a : "";
    }
    return radius;
  };
};

// src/mixins/color.ts
var mergeColorWithOpacity = function mergeColorWithOpacity(colorHex, opacity) {
  var opacityHex = Math.round(opacity * 255).toString(16);
  return "".concat(colorHex).concat(opacityHex.length === 1 ? "0".concat(opacityHex) : opacityHex);
};
var color = function color(name, opacity) {
  return function (_ref2) {
    var theme = _ref2.theme;
    var currentTheme = getAvailableTheme2(theme);
    var tokenName = "color.".concat(name);
    if (tokenName in currentTheme.referenceIndex) {
      var colorHex = currentTheme.referenceIndex[tokenName];
      return opacity || opacity === 0 ? mergeColorWithOpacity(colorHex, opacity) : colorHex;
    }
    if (name in color_exports) {
      var _colorHex = color_exports[name];
      return opacity || opacity === 0 ? mergeColorWithOpacity(_colorHex, opacity) : _colorHex;
    }
    return name;
  };
};
var colorToken = function colorToken(name) {
  return function (_ref3) {
    var theme = _ref3.theme;
    var currentTheme = getAvailableTheme2(theme);
    var tokenName = "";
    var value = name;
    if (name.startsWith("$")) {
      tokenName = name.substr(1);
      value = "";
    } else {
      tokenName = "color.".concat(name);
    }
    if (tokenName in currentTheme.referenceIndex) {
      value = currentTheme.referenceIndex[tokenName];
    }
    return value;
  };
};

// src/mixins/pixelToRem.ts
import { fontSizeMedium } from "@deliveryhero/armor-tokens";
var pixelToRem = function pixelToRem() {
  var pixels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var baseFontSize = arguments.length > 1 ? arguments[1] : undefined;
  return function (props) {
    if (baseFontSize) {
      return "".concat(pixels / baseFontSize, "rem");
    }
    var baseTypography = token("desktopBodyLarge")(props);
    var baseSize = (baseTypography == null ? void 0 : baseTypography.fontSize) || fontSizeMedium;
    return "".concat(parseFloat((pixels / baseSize).toFixed(4)), "rem");
  };
};

// src/mixins/token.ts
var convertToTokenName = function convertToTokenName(rawName) {
  var words = rawName.replace(/[\.-]/g, " ").split(" ");
  if (words.length === 1) {
    return words[0];
  }
  return words[0].toLowerCase() + words.slice(1).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join("");
};
var token = function token(tokenName, fallback, options) {
  return function (props) {
    var currentTheme = getAvailableTheme2(props.theme);
    var tokenNameCamelCase = convertToTokenName(tokenName);
    if (tokenNameCamelCase in currentTheme.referenceIndex) {
      var tokenValue = currentTheme.referenceIndex[tokenNameCamelCase];
      var returnUnit = options == null ? void 0 : options.returnUnit;
      if (!returnUnit || typeof tokenValue === "object") {
        return tokenValue;
      }
      return "".concat(tokenValue).concat(returnUnit);
    }
    if (tokenName in currentTheme.referenceIndex) {
      return currentTheme.referenceIndex[tokenName];
    }
    if (fallback) {
      if (fallback in currentTheme.referenceIndex) {
        var _ref4 = options || {},
          opacity = _ref4.opacity,
          transformToRem = _ref4.transformToRem;
        var fallbackValue = currentTheme.referenceIndex[fallback];
        if (opacity) {
          return mergeColorWithOpacity(fallbackValue, opacity);
        }
        if (transformToRem) {
          return pixelToRem(fallbackValue)(props);
        }
        return fallbackValue;
      }
      if (fallback in color_exports) {
        return color_exports[fallback];
      }
    }
    return fallback != null ? fallback : tokenName;
  };
};

// src/mixins/spacing.ts
var DEFAULT_SPACING_FACTOR = 4;
var spacingCache = /* @__PURE__ */new Map();
var transformValue = function transformValue(_ref5) {
  var spacingInput = _ref5.spacingInput,
    fallback = _ref5.fallback,
    propsWithTheme = _ref5.propsWithTheme;
  var currentTheme = getAvailableTheme2(propsWithTheme.theme);
  var _currentTheme$spacing = currentTheme.spacingFactor,
    spacingFactor = _currentTheme$spacing === void 0 ? DEFAULT_SPACING_FACTOR : _currentTheme$spacing,
    isLegacy = currentTheme.isLegacy;
  var cachedName = isLegacy ? "legacy_".concat(spacingInput) : spacingInput;
  if (spacingCache.has(cachedName)) {
    return spacingCache.get(cachedName);
  }
  var spacingResult;
  if (typeof spacingInput === "number") {
    spacingResult = spacingInput * spacingFactor;
  } else {
    var spacingTokenName = convertToTokenName(spacingInput);
    spacingResult = spacingTokenName in currentTheme.referenceIndex ? currentTheme.referenceIndex[spacingTokenName] : fallback * spacingFactor || spacingInput;
    spacingResult = spacingInput;
    if (fallback === 0 || typeof fallback === "number") {
      spacingResult = fallback * spacingFactor;
    }
    if (spacingTokenName in currentTheme.referenceIndex) {
      spacingResult = currentTheme.referenceIndex[spacingTokenName];
    }
  }
  spacingResult = typeof spacingResult === "number" ? "".concat(spacingResult, "px") : spacingResult;
  spacingCache.set(cachedName, spacingResult);
  return spacingResult;
};
var spacing = function spacing() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return function (propsWithTheme) {
    var lastIndex = inputs.length - 1;
    var hasFallbackValues = Array.isArray(inputs[lastIndex]);
    var fallbackValues = hasFallbackValues ? inputs[lastIndex] : [];
    var inputWithoutFallbackValues = hasFallbackValues ? inputs.slice(0, lastIndex) : inputs;
    return inputWithoutFallbackValues.map(function (spacingInput, index) {
      return transformValue({
        spacingInput: spacingInput,
        fallback: fallbackValues[index],
        propsWithTheme: propsWithTheme
      });
    }).join(" ");
  };
};
var spacingBreakpoint = function spacingBreakpoint(value) {
  return function (_ref6) {
    var theme = _ref6.theme;
    var currentTheme = getAvailableTheme2(theme);
    return currentTheme.breakpoints.mapCodeToValue(value, currentTheme.spacing);
  };
};

// src/mixins/pixelToRemToken.ts
var pixelToRemToken = function pixelToRemToken(name, fallback) {
  return function (props) {
    var value = token(name, fallback)(props);
    if (typeof value === "number") {
      return pixelToRem(value)(props);
    }
    return name;
  };
};

// src/mixins/typography.ts
var typographyInherit = {
  fontFamily: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  letterSpacing: "inherit",
  lineHeight: "inherit"
};
var transformToProperUnit = function transformToProperUnit(value) {
  return function (props) {
    return typeof value === "number" ? pixelToRem(value)(props) : value;
  };
};
var typography = function typography(tokenName, fallback) {
  return function (props) {
    var _a, _b;
    var currentTheme = getAvailableTheme2(props.theme);
    var tokenNameCamelCase = convertToTokenName(tokenName);
    var variant = (_a = currentTheme.typography) == null ? void 0 : _a[tokenNameCamelCase];
    var fallbackVariant = fallback && ((_b = currentTheme.typography) == null ? void 0 : _b[fallback]);
    if (!variant && !fallbackVariant) {
      return typographyInherit;
    }
    var _ref7 = variant || fallbackVariant,
      fontWeight = _ref7.fontWeight,
      letterSpacing = _ref7.letterSpacing,
      lineHeight = _ref7.lineHeight,
      fontFamily = _ref7.fontFamily,
      fontSize = _ref7.fontSize;
    return {
      fontFamily: "".concat(fontFamily, ", sans-serif"),
      fontSize: transformToProperUnit(fontSize)(props),
      fontWeight: fontWeight,
      letterSpacing: letterSpacing,
      lineHeight: transformToProperUnit(lineHeight)(props)
    };
  };
};

// src/mixins/elevation.ts
var elevation = function elevation(level) {
  return function (_ref8) {
    var theme = _ref8.theme;
    var currentTheme = getAvailableTheme2(theme);
    if (level in currentTheme.elevation) {
      return currentTheme.elevation[level];
    }
    return level;
  };
};

// src/mixins/getComponentOverride.ts
var getComponentOverride = function getComponentOverride(componentName) {
  return function (_ref9) {
    var theme = _ref9.theme;
    var _getAvailableTheme = getAvailableTheme2(theme),
      componentCSS = _getAvailableTheme.componentCSS;
    if (componentCSS && componentName in componentCSS) {
      return componentCSS[componentName];
    }
    return null;
  };
};

// src/mixins/gutter.ts
import { css } from "styled-components";
var gutter = function gutter(_ref10) {
  var amount = _ref10.spacing;
  var value = spacing(amount);
  var valueNegative = spacing(amount * -1);
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        margin-right: ", ";\n        margin-bottom: ", ";\n\n        & > * {\n            margin-right: ", ";\n            margin-bottom: ", ";\n        }\n    "])), valueNegative, valueNegative, value, value);
};

// src/mixins/focus.ts
import { css as css2 } from "styled-components";
var getFocusOverrides = function getFocusOverrides(props) {
  return function (_ref11) {
    var theme = _ref11.theme;
    var getOverrides = getComponentOverride("FocusState")({
      theme: theme
    });
    return getOverrides == null ? void 0 : getOverrides(props);
  };
};
var getOutlineFocusStyleFromColor = function getOutlineFocusStyleFromColor(mainColor) {
  return css2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        outline: ", " solid ", ";\n    "])), color(mainColor, 0.4), spacing(1));
};
var getFocusStyleFromColor = function getFocusStyleFromColor(mainColor, outlineColor) {
  return css2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        outline: ", " solid 1px;\n        box-shadow: 0 0 0 ", " ", ";\n    "])), color(outlineColor || mainColor), spacing(1), color(mainColor, 0.4));
};
var resetFocus = function resetFocus() {
  return css2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        &:focus,\n        &:focus-visible,\n        &:focus-within {\n            outline: unset;\n            box-shadow: unset;\n        }\n    "])));
};
var getFocusStyleLegacy = function getFocusStyleLegacy(_ref12) {
  var error = _ref12.error,
    inverse = _ref12.inverse,
    useBorder = _ref12.useBorder;
  var boxShadowColor = "primary.07";
  var borderColor = boxShadowColor;
  if (error) {
    boxShadowColor = "error.07";
    borderColor = "error.07";
  }
  if (inverse) {
    boxShadowColor = "primary.07";
    borderColor = "neutral.00";
  }
  if (error && inverse) {
    boxShadowColor = "error.07";
    borderColor = "neutral.00";
  }
  return css2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        ", "\n        box-shadow: 0 0 0 ", " ", ";\n    "])), useBorder ? css2(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                  border: 1px solid ", ";\n              "])), color(borderColor)) : css2(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                  outline: ", " solid 1px;\n              "])), color(borderColor)), spacing(1), color(boxShadowColor, 0.4));
};
var getFocusStyleNewToken = function getFocusStyleNewToken(_ref13, _ref14) {
  var error = _ref13.error,
    inverse = _ref13.inverse,
    useBorder = _ref13.useBorder;
  var theme = _ref14.theme;
  var tokenName = "base.focus.default";
  if (error) {
    tokenName = "base.focus.danger";
  }
  if (inverse) {
    tokenName = "base.focus.default.inverse";
  }
  if (error && inverse) {
    tokenName = "base.focus.danger.inverse";
  }
  var _token = token(tokenName)({
      theme: theme
    }),
    borderWidth = _token.borderWidth,
    borderColor = _token.borderColor,
    boxShadow = _token.boxShadow;
  return css2(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        ", "\n        box-shadow: ", ";\n    "])), useBorder ? "border: ".concat(borderWidth, "px solid ").concat(borderColor, ";") : "outline: ".concat(borderColor, " solid ").concat(borderWidth, "px;"), boxShadow);
};
var getFocusStyle = function getFocusStyle(props) {
  return function (_ref15) {
    var theme = _ref15.theme;
    var _a = props || {},
      mainColor = _a.mainColor,
      noOutline = _a.noOutline,
      restProps = __objRest(_a, ["mainColor", "noOutline"]);
    var result = css2(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            ", ";\n        "])), transition({
      all: true
    }));
    if (mainColor) {
      return css2(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                ", ";\n                box-shadow: 0 0 0 ", " ", ";\n            "])), result, spacing(1), color(mainColor, 0.4));
    }
    if (isLegacyTheme(theme)) {
      var focusStyle = getFocusStyleLegacy(restProps);
      result = css2(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n            "])), result, focusStyle);
    } else {
      var _focusStyle = getFocusStyleNewToken(restProps, {
        theme: theme
      });
      result = css2(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n            "])), result, _focusStyle);
    }
    if (noOutline) {
      result = css2(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n                ", ";\n                outline-width: 0;\n            "])), result);
    }
    result = css2(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            ", "\n            ", "\n        "])), result, getFocusOverrides(props));
    return result;
  };
};
var focus = function focus(props) {
  return function (propsWithTheme) {
    var _a = props || {},
      disabled = _a.disabled,
      restProps = __objRest(_a, ["disabled"]);
    if (disabled) {
      return "";
    }
    var focusStyle = getFocusStyle(restProps)(propsWithTheme);
    return css2(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n            &:focus-visible {\n                ", "\n            }\n\n            * {\n                &:focus-visible {\n                    ", "\n                }\n            }\n        "])), focusStyle, focusStyle);
  };
};
var focusWithin = function focusWithin(props) {
  return function (propsWithTheme) {
    var _a = props || {},
      disabled = _a.disabled,
      restProps = __objRest(_a, ["disabled"]);
    if (disabled) {
      return "";
    }
    var focusStyle = getFocusStyle(restProps)(propsWithTheme);
    return css2(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n            * {\n                ", ";\n            }\n\n            &:focus-within {\n                ", ";\n            }\n        "])), resetFocus, focusStyle);
  };
};

// src/util/popper.ts
var popperArrowPlacement = function popperArrowPlacement(arrowClassName) {
  return css3(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    &[data-popper-placement^='top'] > .", " {\n        bottom: -8px;\n    }\n\n    &[data-popper-placement^='right'] > .", " {\n        left: -8px;\n    }\n\n    &[data-popper-placement^='bottom'] > .", " {\n        top: -8px;\n    }\n\n    &[data-popper-placement^='left'] > .", " {\n        right: -8px;\n    }\n"])), arrowClassName, arrowClassName, arrowClassName, arrowClassName);
};
var popperArrow = function popperArrow() {
  return css3(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    height: 16px;\n    width: 16px;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &::before {\n        background-color: ", ";\n        width: 10px;\n        height: 10px;\n        content: '';\n        transition: transform 200s ease-out;\n        transform: rotate(45deg);\n        transform-origin: center;\n    }\n"])), token("base.color.flat", "color.neutral.00"));
};
export { popperArrowPlacement, popperArrow, makeBreakpoints, makeArmorSubTheme, makeCompatibility2 as makeCompatibility, createArmorSubTheme, createTheme, createDefaultTheme, createDefaultThemeCached, makeTheme, makeDefaultTheme, makeLightTheme, makeDefaultThemeCached, getAvailableTheme, getAvailableThemeBase, isLegacyTheme, getAvailableTheme2, borderRadius, mergeColorWithOpacity, color, colorToken, pixelToRem, convertToTokenName, token, spacing, spacingBreakpoint, pixelToRemToken, typographyInherit, typography, elevation, getComponentOverride, gutter, getOutlineFocusStyleFromColor, getFocusStyleFromColor, resetFocus, getFocusStyle, focus, focusWithin };